import type { ClientPortfolioToolTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import type {
	InvestmentInstructionInput,
	InvestmentToolInput,
} from "web_myplann/Portfolio/Forms/InvestmentForm/investmentToolSchema";
import {
	DEFAULT_INSTRUCTION_CURRENCY,
	DEFAULT_INSTRUCTION_FREQUENCY,
} from "web_myplann/Portfolio/Forms/ToolsShared/constants";

export const INVESTMENT_INSTRUCTION_DEFAULT_VALUES: InvestmentInstructionInput =
	{
		id: null,
		investmentType: null,
		date: null,
		endedAt: null,
		amount: null,
		currency: DEFAULT_INSTRUCTION_CURRENCY,
		frequency: DEFAULT_INSTRUCTION_FREQUENCY,
		count: null,
	};

export const INVESTMENT_TOOL_DEFAULT_VALUES: InvestmentToolInput = {
	id: null,
	type: null,
	identificationType: null,
	identification: "",
	holdingType: null,
	name: "",
	invested: null,
	value: null,
	valueDate: null,
	valueId: null,
	previousValues: [],
	isAdvisorBond: false,
	instructions: [],
};

export const getNewInvestmentToolDefaultValues = (
	type: ClientPortfolioToolTypeEnum | null = null,
): InvestmentToolInput => ({
	...INVESTMENT_TOOL_DEFAULT_VALUES,
	type,
	valueDate: new Date(),
});
